var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7249 28.0882C29.8324 28.1957 29.9176 28.3232 29.9757 28.4636C30.0339 28.6039 30.0638 28.7544 30.0638 28.9063C30.0638 29.0582 30.0339 29.2086 29.9757 29.349C29.9176 29.4894 29.8324 29.6169 29.7249 29.7243C29.6175 29.8318 29.49 29.917 29.3496 29.9751C29.2093 30.0333 29.0588 30.0632 28.9069 30.0632C28.755 30.0632 28.6045 30.0333 28.4642 29.9751C28.3238 29.917 28.1963 29.8318 28.0888 29.7243L18.5006 20.1347L8.91244 29.7243C8.69548 29.9413 8.40122 30.0632 8.09439 30.0632C7.78757 30.0632 7.49331 29.9413 7.27635 29.7243C7.05939 29.5074 6.9375 29.2131 6.9375 28.9063C6.9375 28.5995 7.05939 28.3052 7.27635 28.0882L16.866 18.5L7.27635 8.91183C7.05939 8.69487 6.9375 8.40061 6.9375 8.09378C6.9375 7.78696 7.05939 7.4927 7.27635 7.27574C7.49331 7.05878 7.78757 6.93689 8.09439 6.93689C8.40122 6.93689 8.69548 7.05878 8.91244 7.27574L18.5006 16.8654L28.0888 7.27574C28.3058 7.05878 28.6001 6.93689 28.9069 6.93689C29.2137 6.93689 29.508 7.05878 29.7249 7.27574C29.9419 7.4927 30.0638 7.78696 30.0638 8.09378C30.0638 8.40061 29.9419 8.69487 29.7249 8.91183L20.1353 18.5L29.7249 28.0882Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.65fc7cfb5c48d45593a0d6000b7ad323.svg";
export { ForwardRef as ReactComponent };